"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTargetEntity = void 0;
var PaymentTargetEntity;
(function (PaymentTargetEntity) {
    PaymentTargetEntity["Order"] = "order";
    PaymentTargetEntity["OrderBundle"] = "orderBundle";
})(PaymentTargetEntity || (exports.PaymentTargetEntity = PaymentTargetEntity = {}));
//# sourceMappingURL=PaymentTargetEntity.js.map